/* HighTide Header JavaScript */

(function () {
  "use strict";

  // Create particles with JavaScript
  function createParticles() {
    const container = document.getElementById("particles-container");
    if (!container) return;

    function createParticle() {
      const particle = document.createElement("div");
      particle.classList.add("particle");

      particle.style.left = Math.random() * 100 + "%";

      const size = Math.random() * 3 + 2;
      particle.style.width = size + "px";
      particle.style.height = size + "px";

      particle.style.animationDuration = Math.random() * 10 + 10 + "s";

      particle.style.animationDelay = Math.random() * 5 + "s";

      container.appendChild(particle);

      setTimeout(() => {
        particle.remove();
      }, 20000);
    }

    // Create initial particles
    for (let i = 0; i < 30; i++) {
      setTimeout(createParticle, i * 300);
    }

    // Continue creating particles
    setInterval(createParticle, 800);
  }

  // Mobile menu toggle
  function initMobileMenu() {
    const mobileToggle = document.getElementById("mobile-menu-toggle");
    const mobileNav = document.getElementById("mobile-nav");

    if (mobileToggle && mobileNav) {
      mobileToggle.addEventListener("click", function () {
        mobileNav.classList.toggle("active");
        this.classList.toggle("active");
      });

      // Close mobile menu when clicking outside
      document.addEventListener("click", function (e) {
        if (mobileNav.classList.contains("active")) {
          if (
            !mobileNav.contains(e.target) &&
            !mobileToggle.contains(e.target)
          ) {
            mobileNav.classList.remove("active");
            mobileToggle.classList.remove("active");
          }
        }
      });
    }
  }

  // Mobile submenu toggle
  function initMobileSubmenus() {
    const mobileNavItems = document.querySelectorAll(".mobile-nav-menu > li");

    mobileNavItems.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector(".mobile-submenu");

      if (submenu) {
        // Prevent default click on parent links with submenus
        link.addEventListener("click", function (e) {
          e.preventDefault();

          // Toggle submenu
          const isOpen = submenu.style.display === "block";

          // Close all other submenus
          document.querySelectorAll(".mobile-submenu").forEach((sub) => {
            if (sub !== submenu) {
              sub.style.display = "none";
            }
          });

          // Toggle current submenu
          submenu.style.display = isOpen ? "none" : "block";
        });
      }
    });
  }

  // Desktop dropdown - prevent parent link navigation and handle dropdown states
  function initDesktopDropdowns() {
    const dropdownParents = document.querySelectorAll(".has-dropdown");

    // Close all dropdowns
    function closeAllDropdowns() {
      dropdownParents.forEach((parent) => {
        parent.classList.remove("dropdown-open");
      });
    }

    // Close dropdowns when clicking outside
    document.addEventListener("click", function (e) {
      if (!e.target.closest(".has-dropdown")) {
        closeAllDropdowns();
      }
    });

    dropdownParents.forEach((parent) => {
      const link = parent.querySelector(".nav-link");

      // Handle mouse enter - close other dropdowns when hovering a new one
      parent.addEventListener("mouseenter", function () {
        // Close other dropdowns
        dropdownParents.forEach((otherParent) => {
          if (otherParent !== parent) {
            otherParent.classList.remove("dropdown-open");
          }
        });
      });

      // Handle mouse leave - close dropdown
      parent.addEventListener("mouseleave", function () {
        parent.classList.remove("dropdown-open");
      });

      // Prevent link navigation on click
      link.addEventListener("click", function (e) {
        e.preventDefault();
      });
    });
  }

  // Update cart count and dropdown
  function updateCartCount() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const cartCount = document.getElementById("cart-count");
        if (cartCount) {
          cartCount.textContent = cart.item_count;
          cartCount.style.display = cart.item_count > 0 ? "flex" : "none";
        }

        // Update cart dropdown
        updateCartDropdown(cart);
      })
      .catch((error) => console.log("Cart update error:", error));
  }

  // Update cart dropdown content
  function updateCartDropdown(cart) {
    const cartDropdownItems = document.getElementById("cart-dropdown-items");
    const cartDropdown = document.getElementById("cart-dropdown");

    if (!cartDropdownItems || !cartDropdown) return;

    if (cart.item_count === 0) {
      cartDropdownItems.innerHTML = `
        <div class="cart-dropdown-empty">
          <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <p>Your cart is empty</p>
        </div>
      `;

      // Hide footer if exists
      const footer = cartDropdown.querySelector(".cart-dropdown-footer");
      if (footer) footer.style.display = "none";
    } else {
      let itemsHTML = "";
      cart.items.forEach((item, index) => {
        const imageURL = item.image
          ? item.image.replace(/\.jpg|\.png|\.gif/, "_100x100$&")
          : "";
        const imageHTML = imageURL
          ? `<img src="${imageURL}" alt="${item.title}" class="cart-item-image">`
          : `<div class="cart-item-image" style="background: rgba(255,255,255,0.2); display: flex; align-items: center; justify-content: center;">
               <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                 <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                 <circle cx="8.5" cy="8.5" r="1.5"></circle>
                 <polyline points="21 15 16 10 5 21"></polyline>
               </svg>
             </div>`;

        itemsHTML += `
          <div class="cart-item" data-line-index="${index + 1}">
            <button class="cart-item-remove" data-line="${
              index + 1
            }" data-key="${item.key}" title="Remove item">×</button>
            ${imageHTML}
            <div class="cart-item-details">
              <div class="cart-item-title">${item.product_title}</div>
              <div class="cart-item-meta">
                <span class="cart-item-quantity">Qty: ${item.quantity}</span>
                <span class="cart-item-price">${formatMoney(
                  item.final_line_price
                )}</span>
              </div>
            </div>
          </div>
        `;
      });

      cartDropdownItems.innerHTML = itemsHTML;

      // Update or create footer
      let footer = cartDropdown.querySelector(".cart-dropdown-footer");
      if (!footer) {
        footer = document.createElement("div");
        footer.className = "cart-dropdown-footer";
        cartDropdown.appendChild(footer);
      }

      footer.style.display = "block";
      footer.innerHTML = `
        <div class="cart-dropdown-total">
          <span class="cart-dropdown-total-label">Total:</span>
          <span class="cart-dropdown-total-price">${formatMoney(
            cart.total_price
          )}</span>
        </div>
        <a href="/cart" class="cart-dropdown-button">View Cart</a>
      `;
    }
  }

  // Format money (basic implementation)
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return `£${amount}`;
  }

  // Initialize cart dropdown functionality
  function initCartDropdown() {
    const cartIconLink = document.getElementById("cart-icon-link");
    const cartDropdown = document.getElementById("cart-dropdown");

    if (cartIconLink && cartDropdown) {
      // Determine cart icon container
      const cartIcon = cartIconLink.closest(".cart-icon");

      // Click behavior:
      // - Mobile (<=768px): allow the link to behave normally (navigate to cart page)
      // - Desktop: prevent navigation and toggle dropdown
      cartIconLink.addEventListener("click", function (e) {
        if (window.innerWidth <= 768) {
          // Let the anchor navigate to the cart page on mobile — no popup
          return;
        }

        // Desktop: toggle dropdown on click
        e.preventDefault();
        cartDropdown.classList.toggle("active");
      });

      // Desktop: open dropdown when entering the icon or the dropdown itself
      // and do not close on mouseleave — close only on outside click
      if (cartIcon) {
        cartIcon.addEventListener("mouseenter", function () {
          if (window.innerWidth > 768) {
            cartDropdown.classList.add("active");
          }
        });

        cartDropdown.addEventListener("mouseenter", function () {
          if (window.innerWidth > 768) {
            cartDropdown.classList.add("active");
          }
        });
      }

      // Close cart dropdown when clicking outside
      document.addEventListener("click", function (e) {
        if (
          !e.target.closest(".cart-icon") &&
          cartDropdown.classList.contains("active")
        ) {
          cartDropdown.classList.remove("active");
        }
      });

      // Handle remove buttons
      initCartRemoveButtons();
    }
  }

  // Initialize remove buttons for cart items
  function initCartRemoveButtons() {
    document.addEventListener("click", function (e) {
      if (e.target.classList.contains("cart-item-remove")) {
        e.preventDefault();
        const key = e.target.getAttribute("data-key");
        const lineIndex = e.target.getAttribute("data-line");

        if (key) {
          removeCartItem(key, lineIndex);
        }
      }
    });
  }

  // Remove item from cart
  function removeCartItem(key, lineIndex) {
    const removeButton = document.querySelector(
      `.cart-item-remove[data-key="${key}"]`
    );
    if (removeButton) {
      removeButton.textContent = "...";
      removeButton.disabled = true;
    }

    fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: key,
        quantity: 0,
      }),
    })
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count and dropdown
        updateCartCount();

        // Dispatch cart updated event
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { count: cart.item_count },
          })
        );
      })
      .catch((error) => {
        console.error("Error removing item:", error);
        if (removeButton) {
          removeButton.textContent = "×";
          removeButton.disabled = false;
        }
        alert("Error removing item from cart. Please try again.");
      });
  }

  // Rotating top bar messages
  function initTopBarMessages() {
    const messages = document.querySelectorAll(".top-bar-message");
    if (messages.length === 0) return;

    let currentIndex = 0;

    function showMessage(index) {
      messages.forEach((msg, i) => {
        if (i === index) {
          msg.classList.add("active");
        } else {
          msg.classList.remove("active");
        }
      });
    }

    // Show first message
    showMessage(currentIndex);

    // Rotate messages every 4 seconds
    setInterval(() => {
      currentIndex = (currentIndex + 1) % messages.length;
      showMessage(currentIndex);
    }, 4000);
  }

  // Initialize everything
  function init() {
    createParticles();
    initMobileMenu();
    initMobileSubmenus();
    initDesktopDropdowns();
    initCartDropdown();
    updateCartCount();
    initTopBarMessages();

    // Listen for cart updates
    document.addEventListener("cart:updated", updateCartCount);
  }

  // Run on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
